import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { saveEditorDraft as saveEditorDraftAction, removeEditorDraft as removeEditorDraftAction, } from '../../DaEditorWrapper/redux/actionCreators';
import { useEditorDraftState } from './useEditorDraftState';
/** Returns functions that help manage editor drafts.  */
export function useEditorDraftActions(editorId) {
    var draftValue = useEditorDraftState(editorId);
    var dispatch = useDispatch();
    var saveEditorDraft = useCallback(function (state) {
        dispatch(saveEditorDraftAction(editorId, state));
    }, [dispatch, editorId]);
    var removeEditorDraft = useCallback(function () {
        if (draftValue) {
            dispatch(removeEditorDraftAction(editorId));
        }
    }, [dispatch, editorId, draftValue]);
    return {
        /**
         * Saves the editor draft to redux and local storage.
         */
        saveEditorDraft: saveEditorDraft,
        /**
         * Removes the editor draft from redux and local storage.
         */
        removeEditorDraft: removeEditorDraft,
    };
}
//# sourceMappingURL=useEditorDraftActions.js.map